import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { getListItems } from "./util";
import { Avatar, Box, Group, SegmentedControl, Stack } from "@mantine/core";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: ".8rem",
  },
  textWrapper: {
    display: "flex",
  },
  list: {
    backgroundColor: theme.app.background[0],
  },
  listItemInactive: {
    "&:hover": {
      color: theme.app.labelColor,
    },
  },
  active: {
    backgroundColor: "rgba(0,0,0,0.08)",
    outline: `2px solid ${theme.app.primaryColors.main}`,
    borderRadius: "5px",
    cursor: "default",
    pointerEvents: "none",
  },
  select: {
    fontSize: "1rem !important",
    fontWeight: 500,
  },
}));

const Managing = React.memo(function Managing(props) {
  const {
    active,
    bookingData,
    handleSelect,
    isNew,
    setIsNew,
    isOccasion,
    manages,
  } = props;
  const classes = useStyles();
  const language = useSelector((state) => state.language);
  const [users, setUsers] = useState([]);
  const [value, setValue] = useState("react");
  const managingItems = getListItems(manages, bookingData, isNew, language);

  useEffect(() => {
    let user =
      managingItems &&
      managingItems.reduce((acc, curr) => {
        if (curr) {
          console.log(curr.photo);
          acc.push({
            value: curr.id,
            label: (
              <Group
                my={5}
                className={
                  curr.id === active
                    ? classes.listItem
                    : !curr.disabled
                    ? classes.listItemInactive
                    : undefined
                }
              >
                <Avatar
                  alt={language.profilePicture}
                  src={curr.photo}
                  style={{ width: "45px", height: "45px" }}
                  radius={"50%"}
                />
                <Stack spacing={0}>
                  <Box ml={10} style={{ textAlign: "left" }}>
                    {curr.primaryText}
                  </Box>
                  <Box ml={10}>{curr.secondaryText}</Box>
                </Stack>
              </Group>
            ),
            disabled: curr.disabled,
          });
        }
        return acc;
      }, []);

    if (!isNew && !isOccasion) {
      user.push({
        value: "0000",
        label: (
          <Group
            my={5}
            className={
              active === "0000" ? classes.listItem : classes.listItemInactive
            }
          >
            <Avatar
              alt={language.profilePicture}
              src={"curr.photo"}
              style={{ width: "45px", height: "45px" }}
              radius={"50%"}
            />
            <Stack spacing={0}>
              <Box ml={10} style={{ textAlign: "left" }}>
                {language.otherParticipant}
              </Box>
              <Box ml={10} style={{ textAlign: "left" }}>
                {language.otherParticipantSubtext}
              </Box>
            </Stack>
          </Group>
        ),
        disabled: isNew,
      });
    }
    setUsers(user);
  }, []);

  useEffect(() => {
    if (active === "0000") setIsNew(true);
    if (active !== "0000") setIsNew(false);
  }, [value]);

  if (!manages || !users) return null;

  return (
    <div className={classes.wrapper}>
      <label htmlFor="manages-selector" className={classes.select}>
        {language.choosePerson}
      </label>
      <SegmentedControl
        id="manages-selector"
        value={value}
        onChange={(e) => {
          setValue(e);
          handleSelect(e);
        }}
        data={users}
        orientation="vertical"
        fullWidth
        radius="sm"
        size="md"
        color="violet.8"
        mt={12}
        classNames={{ root: classes.list, label: classes.listItem }}
      />
    </div>
  );
});

export default Managing;
